import { IUserAutocomplete } from 'auth/types';
import { objectKeysSnakeCaseToCamelCase } from 'core/utils';

export const getUserIdAndName = (user: IUserAutocomplete): string => {
  if (!user) {
    return '';
  }

  const userToCamelCase = objectKeysSnakeCaseToCamelCase(user);

  return [`#${userToCamelCase.id}`, userToCamelCase.firstName, userToCamelCase.lastName]
    .filter(Boolean)
    .join(' ');
};
